module.exports = __webpack_public_path__ + "static/media/beeflamb.a4ed91a1.jpg";